import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      descriptionPrefix: '<span class="t-500">Description: </span>'
    }
  },
  computed: {
    title () {
      return this.highlights && this.highlights.title ? this.highlights.title[0] : this.data.title
    },
    description () {
      if (!this.isEmpty(this.highlights['texts.value'])) {
        return `${this.descriptionPrefix} ${this.stripTagsNoMark(this.highlights['texts.value'][0])}`
      } else if (!this.isEmpty(this.data.texts)) {
        return `${this.descriptionPrefix} ${this.stripTags(this.data.texts[0].value)}`
      }
      return ''
    },
    researchers () {
      return this.data.participants
    },
    organisations () {
      return !this.isEmpty(this.data.organisations) ? this.data.organisations : []
    },
    dateString () {
      const start = this.data.start_date
      const end = this.data.end_date
      if (start || end) {
        return `${start ? this.$options.filters.formatDate(start, 'YYYY') : ' '} - ${end ? this.$options.filters.formatDate(end, 'YYYY') : ' '}`
      }
      return ''
    },
    keywords () {
      if (!this.data.keywords) return null
      return this.data.keywords.map(k => {
        return this.$options.filters.titleize(k.keyword)
      }).join(', ')
    }
  }
}
